import * as mutationType from "../mutation_types";
import userStatuses from "@/helpers/enums/userStatuses";

const state = {
  profile: {},
  userRecordId: ""
};

const getters = {
  profile: state => state.profile,
  is_active: state =>
    state.profile.statusId != userStatuses.ADDED ||
    !state.profile.requireUserAccount
};

const actions = {
  getProfile({ commit }, request) {
    return new Promise((resolve, reject) => {
      let url = "/api/survey/" + request.id + "/profile";
      if (request.is_preview) {
        url += "?preview=true";
      }
      this._vm.$http
        .get(url)
        .then(res => {
          commit(mutationType.SET_PROFILE, res.data);
          commit(mutationType.SET_USERRECORDID, request.id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveProfile({ commit, state }, profile) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/survey/" + state.userRecordId + "/profile", profile)
        .then(res => {
          commit(mutationType.SET_PROFILE, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  uploadAvatar({ commit, state }, file) {
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      formData.append("file", file);
      this._vm.$http
        .post(
          "/api/survey/" + state.userRecordId + "/profile/avatar",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(res => {
          commit(mutationType.SET_PROFILE_AVATAR, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getRegisterProfile({ commit }, id) {
    return new Promise((resolve, reject) => {
      let url = "/api/survey/" + id + "/register";
      this._vm.$http
        .get(url)
        .then(res => {
          commit(mutationType.SET_PROFILE, res.data);
          commit(mutationType.SET_USERRECORDID, id);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveRegisterProfile({ commit, state }, profile) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(
          "/api/survey/" + state.userRecordId + "/register/validate",
          profile
        )
        .then(res => {
          if (res.data) {
            this._vm.$http
              .post("/api/survey/" + state.userRecordId + "/register", profile)
              .then(res => {
                commit(mutationType.SET_PROFILE, res.data);
                resolve(res.data.initialSurveyUrl);
              })
              .catch(error => {
                console.log(error);
                reject(error);
              });
          } else {
            reject({ emailExists: true });
          }
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_PROFILE](state, profile) {
    state.profile = profile;
  },
  [mutationType.SET_USERRECORDID](state, id) {
    state.userRecordId = id;
  },
  [mutationType.SET_PROFILE_AVATAR](state, url) {
    state.profile.avatarUrl = url;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
